module.exports = __webpack_public_path__ + "img/hhi.a5067da9.png";